module.exports = __webpack_public_path__ + "static/media/emilytam.51b08e31.jpeg";